import React, { useState } from 'react';
import { apiGitBranches } from '../helpers/apiHelpers';
import BranchTypeahead from './BranchTypeahead';
import PencilAltIcon from '@patternfly/react-icons/dist/esm/icons/pencil-alt-icon';
import { useStableAccessToken } from '../hooks/useStableAccessToken';

export interface EditableBranchCellProps {
  application: string;     
  repoName: string;     
  branchValue: string;
  onChange: (newValue: string) => void;
}

const EditableBranchCell: React.FC<EditableBranchCellProps> = ({
  application,
  branchValue,
  repoName,
  onChange,
}) => {
  const [editing, setEditing] = useState(false);
  const [branches, setBranches] = useState<string[]>([]);
  const [fetched, setFetched] = useState(false);
  const [loading, setLoading] = useState(false);

  // Call the hook at the top level. This hook returns a function to get the access token.
  const tokenGetter = useStableAccessToken();

  const handleSelect = (value: string) => {
    onChange(value);
    setEditing(false);
  };

  const handleEditClick = async () => {
    setEditing(true);
    // Only fetch once per application cell
    if (!fetched && (repoName || application)) {
    setLoading(true);
      try {
        // use repoName if provided; fall back to application
        const appId = repoName || application;
        const newBranches = await apiGitBranches(appId, branchValue, tokenGetter);
        setBranches(newBranches);
        setFetched(true);
      } catch (error) {
        console.error('Error fetching branches for', application, error);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {editing ? (
        loading ? (
          <div className="dx-spinner dx-spinner--sm" aria-label="Loading branches…" />
        ) : (
          <BranchTypeahead
            value={branchValue}
            onSelect={handleSelect}
            label="Select branch"
            branchOptions={branches}
          />
        )
      ) : (
        <>
          <span style={{ flexGrow: 1 }}>
            {branchValue || <i>No branch selected</i>}
          </span>
          <button
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: 0,
              marginLeft: '5px',
            }}
            onClick={handleEditClick}
            aria-label="Edit branch"
          >
            <PencilAltIcon />
          </button>
        </>
      )}
    </div>
  );
};

export default EditableBranchCell;
